import axios from '@/api/requests/axios'

const config = { stayOnForbidden: true }

export default {
  get: () => axios.get('/api/admin/v1/exchange-storage', config),

  updateSettings: terms => axios.put('/api/admin/v1/exchange-storage/settings', terms, config),

  purge: sections => axios.post('/api/admin/v1/exchange-storage/purge', { sections }, config),
}
